/**
 * Utility to request browser location permission and store it in localStorage.
 * Returns a promise that resolves with the position or rejects with an error.
 */
export const requestLocationPermission = (): Promise<GeolocationPosition> => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by your browser."));
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        localStorage.setItem("location", JSON.stringify({ lat: latitude, long: longitude }));
        resolve(position);
      },
      (error) => {
        console.error("Geolocation error:", error);
        reject(error);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000, // 10 seconds timeout for user to respond
        maximumAge: 0, // Always get fresh location
      },
    );
  });
};

/**
 * Checks if location is already stored in localStorage.
 */
export const hasStoredLocation = (): boolean => {
  const locationString = localStorage.getItem("location");
  if (!locationString) return false;
  try {
    const location = JSON.parse(locationString);
    return !!(location && location.lat && location.long);
  } catch {
    return false;
  }
};
